import { createApp, h } from 'vue';
import App from './App.vue';
import store from '@/store';

import 'material-design-icons-iconfont/dist/material-design-icons.css';

import vuetify from '@/plugins/vuetify';
import router from '@/plugins/router';
import i18n from '@/plugins/i18n';
import pinia from '@/plugins/pinia';
import '@/plugins/vee-validate';
import '@/plugins/appinsights';

import AppLayout from '@/views/common/layouts/AppLayout';
import PublicLayout from '@/views/common/layouts/PublicLayout';

const app = createApp({
  render: () => h(App)
});

app.use(pinia)
  .use(store)
  .use(router)
  .use(vuetify)
  .use(i18n);

app.component('AppLayout', AppLayout);
app.component('PublicLayout', PublicLayout);

app.config.devtools = process.env.VUE_APP_DEV_TOOLS;

app.mount('#app');

export default app;
